import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import AppSlider from './AppSlider';
import FacetsLoader from '../Loader/FacetsLoader';

const ClientsAmountFilter = ({ onChange, reset }) => {
  const { clientFacetData, dealFacetData, isGetFasets } = useSelector(({ search }) => ({
    clientFacetData: search.clientFacetData,
    dealFacetData: search.dealFacetData,
    isGetFasets: search.isGetFasets,
  }));

  const amountRangeMinMax = useMemo(
    () => dealFacetData?.amount || clientFacetData.amountRangeMinMax,
    [dealFacetData, clientFacetData]
  );
  const [min, max] = amountRangeMinMax;

  const handleChange = (values) => {
    onChange(values);
  };

  const renderSlider = () => {
    return isGetFasets ? (
      <FacetsLoader />
    ) : (
      <AppSlider
        step={1}
        min={min}
        max={max}
        values={amountRangeMinMax}
        onChange={handleChange}
        reset={reset}
      />
    );
  };

  return (
    <div className="content-inner-data-aside-left">
      <div className="content-card-row-title">Сумма микрозайма</div>
      <div className="content-card-row">{renderSlider()}</div>
    </div>
  );
};

export default ClientsAmountFilter;
